function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F01919",
  strokeLinecap: "square",
  opacity: 0.98
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.762 5.516v11.25M12.386 11.142H1.136"
})), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.25,
  d: "M41.411 11.14h-11.25"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 1.94,
  d: "M25.278 1.475l-8.007 18.05"
}));

var SvgPlusOrMinus = function SvgPlusOrMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 21,
    viewBox: "0 0 43 21"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/plus-or-minus.8e8dc527.svg";
export { SvgPlusOrMinus as ReactComponent };